import { Breadcrumb } from 'antd';
import styles from './Breadcrumb.module.less';
import { Link } from 'react-router-dom';

export interface IRoutes {
	path: string;
	breadcrumbName: string;
}

export interface Route {
	path: string;
	breadcrumbName: string;
	children?: Omit<Route, 'children'>[];
}

export interface IProps {
	routes: IRoutes[];
}

export default function BreadCrumb(props: IProps) {
	const { routes } = props;

	function itemRender(
		route: Route,
		params: any,
		routes: Array<Route>,
		paths: Array<string>,
	) {
		const last = routes.indexOf(route) === routes.length - 1;
		return last ? (
			<span>{route.breadcrumbName}</span>
		) : (
			<Link to={`/${paths.join('/')}`}>{route.breadcrumbName}</Link>
		);
	}
	return (
		<div className={styles.container} data-testid="breadcrumb">
			<Breadcrumb routes={routes} itemRender={itemRender} />
		</div>
	);
}
